/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const GoodsInListService = {
  dataSourceConfig(url, params) {
    // var url = "api/PurchaseOrderList";
    return ApiService.createDataSource(url, params);
  },
  async getPurchaseOrderByCode(code) {
    const requestScreenData = {
      url: "api/PurchaseOrderList",
      top: "1",
      filter: `Code eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { GoodsInListService };
